import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import get from "lodash-es/get";

import DropdownLabeled from "../Dropdown";

export const FormDropdownLabeled = (props) => {
  const { name, label, items, helperText, ...otherProps } = props;
  const formik = useFormikContext();

  const value = get(formik.values, name, "");
  const touched = get(formik.touched, name, false);
  const error = get(formik.errors, name, "");
  const hasError = Boolean(error);

  return (
    <DropdownLabeled
      name={name}
      value={value}
      label={label}
      onChange={formik.handleChange}
      error={touched && hasError}
      helperText={(touched && error) || helperText}
      items={items}
      {...otherProps}
    />
  );
};

FormDropdownLabeled.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.array,
  label: PropTypes.string,
  helperText: PropTypes.string,
};
